import type { ReactNode } from 'react';

export interface PageHeadProps {
  readonly title: ReactNode;
  /**
   * Plain-text name of the heading, for a `title` whose markup carries line
   * break hints (<wbr>, e.g. SoftBreaks around an e-mail): the heading keeps
   * the exact text as its accessible name. Omit it for a plain title.
   */
  readonly titleLabel?: string;
  readonly subtitle?: ReactNode;
  readonly crumb?: ReactNode;
  readonly actions?: ReactNode;
}

export function PageHead({ title, titleLabel, subtitle, crumb, actions }: PageHeadProps): JSX.Element {
  return (
    <header className="adm-page-head">
      <div>
        {crumb ? <div className="crumb">{crumb}</div> : null}
        <h1 aria-label={titleLabel}>{title}</h1>
        {subtitle ? <p className="sub">{subtitle}</p> : null}
      </div>
      {actions ? <div className="actions">{actions}</div> : null}
    </header>
  );
}
